import type { SxProps, Theme } from '@mui/material';
import { Skeleton, TableCell } from '@mui/material';

import { renderRestrictedOrValue } from './tableHelpers';

type Props = {
  isLoading: boolean;
  hasValue: boolean;
  displayValue: string;
  restricted: boolean | undefined;
  skeletonWidth?: number;
  sx?: SxProps<Theme>;
};

const ValueCell = ({
  isLoading,
  hasValue,
  displayValue,
  restricted,
  skeletonWidth = 60,
  sx
}: Props) => (
  <TableCell
    align='right'
    sx={sx}
  >
    {isLoading && !hasValue ? (
      <Skeleton
        variant='text'
        width={skeletonWidth}
        sx={{ ml: 'auto' }}
      />
    ) : (
      renderRestrictedOrValue(displayValue, restricted)
    )}
  </TableCell>
);

export default ValueCell;
